import React from 'react';
import { Typography, Row } from 'antd';
import styled from 'styled-components';


const { Title } = Typography;

const StyledTitle = styled(Title)`
    @media (max-width: ${props => props.theme.breakpoint.sm}px) {
        font-size: ${props => props.theme.unit * 3}px !important;
    }
`;

const FormStepTitle = ({ label }) => {
    return (
        <>
            <Row>
                <StyledTitle level={2}>
                    { label }
                </StyledTitle>
            </Row>
            <br />
        </>
    );
};

export default FormStepTitle;
